module.exports = __webpack_public_path__ + "dist/img/how-it-works-car.b89ff7fc.svg";